module.exports = __webpack_public_path__ + "static/media/chevron-up.19574d3a.svg";